export class UrlTokenParser {
  _browser

  constructor(browser) {
    this._browser = browser;
  }

  parseToken() {
    const url = this._browser.getCurrentUrl();
    const pattern = new RegExp(`${process.env.TOKEN_NAME}=([^&#]+)\&?`);

    const result = pattern.exec(url);

    if(!result || result.length != 2) {
      return null;
    }

    const tokenQueryParam = result[0]
    const token = decodeURIComponent(result[1]);

    const updatedUrl = url.replace(tokenQueryParam, "");
    this._browser.changeUrlWithoutReload(updatedUrl);

    return token;
  }
}